/* istanbul ignore file */
import React from 'react';
import { EnumField } from 'framework/ui/field';
import { OFFICE_LABEL } from './constants';

const OfficeCodeField = (props: any) => {
  return (
    <EnumField
      {...props}
      options={{
        ...OFFICE_LABEL,
        'Austin-1': 'Austin',
        'Minsk-1': 'Minsk',
        'Krakow-1': 'Krakow',
        'Tbilisi-1': 'Tbilisi',
      }}
    />
  );
};

export default OfficeCodeField;
